import * as sceneMarketing from '../services/sceneMarketing';

export default {
  namespace: 'sceneMarketing',

  state: {
    sceneMarketingList: null,
    memberLevel: [],
    sceneMarketingDetail: null,
    isAddSuccess: null,
    isSuspend: null,
    isUpdate: null,
    companyList: null,
    wechatTemplateList: null,
    smsTemplateList: null,
    isApprove: null,
    isRestart: null,
    coupons: null,
    allCoupons: {},
    couponsList: [],
    couponIds: null,
    diffMember: [],
    skuProduct: [],
    seriesProduct: [],
    stylesProduct: [],
    goodsProduct: [],
    reasonProduct: [],
    subclassProduct: [],
    designProduct: [],
    categoryProduct: [],
  },

  effects: {
    //场景营销列表
    *getSceneMarketingList({ payload: { values } }, { call, put }) {
      const response = yield call(sceneMarketing.getSceneMarketingList, values);
      yield put({
        type: 'save',
        payload: {
          sceneMarketingList: response?.data,
        },
      });
    },
    //  查询活动详情
    *getSceneMarketingDetail({ payload: { values } }, { call, put }) {
      const response = yield call(
        sceneMarketing.getSceneMarketingDetail,
        values,
      );
      const productRulesList = response.data.productRulesList;
      if (productRulesList) {
        const newArr = productRulesList;
        newArr.forEach((element) => {
          if (typeof element?.coupons === 'string') {
            const reg = /\\/g;
            element['coupons'] = JSON.parse(element?.coupons?.replace(reg));
          }
        });
      }
      const skuProduct = productRulesList.filter((i) => i?.addType === null);
      const seriesProduct = productRulesList.filter(
        (i) => i?.addType === 'SERIES',
      );
      const stylesProduct = productRulesList.filter(
        (i) => i?.addType === 'SPU',
      );
      const goodsProduct = productRulesList.filter(
        (i) => i?.addType === 'MATERIAL_CODE',
      );
      const reasonProduct = productRulesList.filter(
        (i) => i?.addType === 'SEASON',
      );
      const subclassProduct = productRulesList.filter(
        (i) => i?.addType === 'SUBCLASS',
      );
      const designProduct = productRulesList.filter(
        (i) => i?.addType === 'STYLE',
      );
      const categoryProduct = productRulesList.filter(
        (i) => i?.addType === 'GENERAL_CATEGORY',
      );
      yield put({
        type: 'save',
        payload: {
          sceneMarketingDetail: response?.data,
          skuProduct: skuProduct,
          seriesProduct: seriesProduct,
          stylesProduct: stylesProduct,
          goodsProduct: goodsProduct,
          reasonProduct: reasonProduct,
          subclassProduct: subclassProduct,
          designProduct: designProduct,
          categoryProduct: categoryProduct,
        },
      });
    },
    // 创建活动详情
    *handleAddSceneMarketing({ payload: { values }, callback }, { call, put }) {
      const response = yield call(
        sceneMarketing.handleAddSceneMarketing,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          isAddSuccess: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 暂停/终止活动
    *handleSuspendSceneMarketing(
      { payload: { values }, callback },
      { call, put },
    ) {
      const response = yield call(
        sceneMarketing.handleSuspendSceneMarketing,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          isSuspend: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 场景营销审批
    *ApproveSceneMarketing({ payload: { values }, callback }, { call, put }) {
      const response = yield call(sceneMarketing.ApproveSceneMarketing, values);
      yield put({
        type: 'save',
        payload: {
          isApprove: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 更新活动详情
    *handleUpdateSceneMarketing(
      { payload: { values }, callback },
      { call, put },
    ) {
      const response = yield call(
        sceneMarketing.handleUpdateSceneMarketing,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          isUpdate: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *RestartSceneMarketing({ payload: { values }, callback }, { call, put }) {
      const response = yield call(sceneMarketing.RestartSceneMarketing, values);
      yield put({
        type: 'save',
        payload: {
          isRestart: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //会员等级
    *getMemberLevel({ payload: { values }, callback }, { call, put }) {
      const response = yield call(sceneMarketing.getMemberLevel, values);
      const memberLevel = response?.data || [];
      memberLevel.sort((a, b) => a.code - b.code);
      yield put({
        type: 'save',
        payload: {
          memberLevel,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //获取公司接口
    *getCompanyList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(sceneMarketing.getCompanyList, values);
      yield put({
        type: 'save',
        payload: {
          companyList: response?.data[0]?.subCompany,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 校验场景营销活动是否可以创建
    *getIsCreated({ payload: { values }, callback }, { call, put }) {
      const response = yield call(sceneMarketing.getIsCreated, values);
      yield put({
        type: 'save',
        payload: {
          creatList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 获取微信模板
    *getWechatTemplateList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(sceneMarketing.getWechatTemplateList, values);
      yield put({
        type: 'save',
        payload: {
          wechatTemplateList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 获取短信模板消息
    *getSmsTemplateList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(sceneMarketing.getSmsTemplateList, values);
      yield put({
        type: 'save',
        payload: {
          smsTemplateList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 存储优惠券的值
    *saveItemCoupons({ payload: { value } }, { put, select }) {
      const val = JSON.parse(JSON.stringify(value));
      const data = yield select((state) => state.sceneMarketing.allCoupons);
      data[value.id] = val.coupons;
      yield put({
        type: 'save',
        payload: {
          allCoupons: data,
        },
      });
      yield put({
        type: 'save',
        payload: {
          id: val.id,
          coupons: val.coupons,
        },
      });
    },
    // 存储优惠券列表的值
    *saveCouponsList({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          couponsList: value,
        },
      });
    },
    // 存储优惠券id
    *saveCouponsId({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          couponIds: value,
        },
      });
    },
    // diffMember
    *saveDiffMember({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          diffMember: value,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
    delete(state) {
      // console.log(action.payload, 'state, action');
      return {
        ...state,
        sceneMarketingDetail: undefined,
        allCoupons: [],
        couponIds: null,
        diffMember: [],
        skuProduct: [],
        seriesProduct: [],
        stylesProduct: [],
        goodsProduct: [],
        reasonProduct: [],
        subclassProduct: [],
        designProduct: [],
        categoryProduct: [],
        memberLevel: [],
      };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          props.pathname?.includes('/festival') ||
          props.pathname?.includes('/registration') ||
          props.pathname?.includes('/birthday') ||
          props.pathname?.includes('/member') ||
          props.pathname?.includes('/level_change') ||
          props.pathname?.includes('/point_use') ||
          props.pathname?.includes('/consumption') ||
          props.pathname?.includes('/bind') ||
          props.pathname?.includes('/scene/detail') ||
          props.pathname?.includes('/repurchase')
        ) {
          dispatch({
            type: 'sceneMarketing/delete',
          });
        }
      });
    },
  },
};
